import React, { useEffect, useState } from "react";
import { adminApi } from "../api/adminApi";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from "@material-ui/core";

export default function EditUserRolesModal({ open, user, onClose, onSaved }) {
    const [roles, setRoles] = useState([]);
    const [selected, setSelected] = useState(user.roles || []);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        adminApi.getRoles().then(setRoles);
    }, []);

    useEffect(() => {
        setSelected(user.roles || []);
    }, [user]);

    const toggleRole = (roleName) => {
        setSelected((prev) =>
            prev.includes(roleName)
                ? prev.filter((r) => r !== roleName)
                : [...prev, roleName]
        );
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            await adminApi.setUserRoles(user.id, selected);
            onSaved && onSaved();
            onClose();
        } catch (err) {
            console.error(err);
            alert("Fehler beim Aktualisieren der Rollen.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Rollen für {user.userName}</DialogTitle>
            <DialogContent dividers>
                <FormGroup>
                    {roles.map((r) => (
                        <FormControlLabel
                            key={r.id}
                            control={
                                <Checkbox
                                    checked={selected.includes(r.name)}
                                    onChange={() => toggleRole(r.name)}
                                    color="primary"
                                />
                            }
                            label={r.name}
                        />
                    ))}
                </FormGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving ? "Speichern..." : "Speichern"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
